import CampaignHeader from './crowdfunding_campaign_header'
import { connect } from 'react-redux'
import { getFullName } from 'griffin'
import {
  getCampaignSelector,
  getCampaignCategorySelector,
} from 'redux/selectors/campaign'
import { getInitials } from 'shared/helpers/name_helpers'
import { generateCategoryName } from 'client/lib/category'

const mapStateToProps = (state, ownProps) => {
  const campaign = getCampaignSelector(state, ownProps)
  const ownerName =
    campaign.owner.business_name ||
    getFullName({
      givenName: campaign.owner.first_name,
      surname: campaign.owner.last_name,
    })
  const category = getCampaignCategorySelector(state, ownProps)
  const categoryName = generateCategoryName(state, category)

  return {
    poolName: campaign.title,
    categoryName,
    creatorName: ownerName,
    charity: campaign.charity,
    end_date: campaign.end_date,
    profileImage: campaign.owner.profile_photo,
    initials: getInitials(ownerName),
    ...ownProps,
  }
}

export default connect(mapStateToProps)(CampaignHeader)
